var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-latest-articles" }, [
    _vm.latestArticles.MainArticle
      ? _c(
          "div",
          { staticClass: "wf-latest-articles-main" },
          [
            _c("pc-responsive-image", {
              attrs: {
                desktopSrc: _vm.latestArticles.MainArticle.FeatureImageDesktop,
                mobileSrc: _vm.latestArticles.MainArticle.FeatureImageMobile,
                imageAlt: _vm.latestArticles.MainArticle.FeatureImageAltText,
                imageCss: "background-image object-position-center"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "wf-latest-articles-main-content" }, [
                _c("div", { staticClass: "secondary-heading" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.latestArticles.MainArticle.Category) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("h3", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.latestArticles.MainArticle.Title) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "wf-article-date" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.latestArticles.MainArticle.Date) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "mb-2",
                  domProps: {
                    innerHTML: _vm._s(_vm.latestArticles.MainArticle.Summary)
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "wf-latest-articles-main-buttons" },
                  [
                    _vm.latestArticles.MainArticle.Type == "Videos"
                      ? _c(
                          "div",
                          { staticClass: "vue-wf-video-modal-button" },
                          [
                            _c(
                              "wf-video-modal-button",
                              {
                                attrs: {
                                  "css-class":
                                    "call-to-action-button btn btn-white border-dark",
                                  "video-type": "element",
                                  "video-data": "@Model.MainArticle.Media1"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Watch now\n              "
                                ),
                                _c("span", {
                                  class:
                                    "png-icon png-icon-icons-glyph--k-play-fill"
                                })
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("pc-call-to-action-button", {
                      attrs: {
                        title: "View article",
                        url: _vm.latestArticles.MainArticle.Url,
                        reverseColors: true
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wf-latest-articles-additional" },
      [
        _c("div", { staticClass: "wf-latest-articles-title" }, [
          _c("h2", { staticClass: "h3 m-0" }, [
            _vm._v("\n        " + _vm._s(_vm.latestArticles.Title) + "\n      ")
          ])
        ]),
        _vm._v(" "),
        _vm._l(_vm.latestArticles.AdditionalArticles, function(article, index) {
          return _c(
            "div",
            {
              key: "latest-article" + index,
              staticClass: "wf-latest-articles-additional-item"
            },
            [
              _c(
                "div",
                { staticClass: "wf-latest-articles-additional-image" },
                [
                  _c("img", {
                    staticClass: "image",
                    class: article.CssClasses,
                    attrs: {
                      src: article.TeaserImage,
                      alt: article.TeaserImageAltText
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "wf-latest-articles-additional-content" },
                [
                  _c("div", { staticClass: "secondary-heading" }, [
                    _vm._v(
                      "\n          " + _vm._s(article.Category) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("h3", [
                    _vm._v(
                      "\n          " + _vm._s(article.Title) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "wf-article-date" }, [
                    _vm._v("\n          " + _vm._s(article.Date) + "\n        ")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "mb-2",
                    domProps: { innerHTML: _vm._s(article.Summary) }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wf-latest-articles-main-buttons" },
                    [
                      article.Type == "Videos"
                        ? _c(
                            "div",
                            { staticClass: "vue-wf-video-modal-button" },
                            [
                              _c(
                                "wf-video-modal-button",
                                {
                                  attrs: {
                                    "css-class":
                                      "call-to-action-button btn btn-white border-dark",
                                    "video-type": "element",
                                    "video-data": article.Media1
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Watch now\n              "
                                  ),
                                  _c("span", {
                                    class:
                                      "png-icon png-icon-icons-glyph--k-play-fill"
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("pc-call-to-action-button", {
                        attrs: {
                          url: article.Url,
                          reverseColors: true,
                          title: "View Article"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }